/*jshint browser:true */
/*!
* FitVids 1.1
*
* Copyright 2013, Chris Coyier - http://css-tricks.com + Dave Rupert - http://daverupert.com
* Credit to Thierry Koblentz - http://www.alistapart.com/articles/creating-intrinsic-ratios-for-video/
* Released under the WTFPL license - http://sam.zoy.org/wtfpl/
*
*/



jQuery('.open-popup-link').magnificPopup({
  type:'inline',
  midClick: true 
});

jQuery(document).ready(function($) {
  TweenMax.to($('.browse-validation'), 0.3, {ease: Power4.easeInOut, height: 0, opacity: 0});
  TweenMax.to(jQuery('#gform_14 .gform_footer'), 0.3, {ease: Power4.easeInOut, height: 0, opacity: 0, padding: 0, margin: 0});

  $(".browse-password").bind("paste keyup keypress change", function(e) {
      $('.browse-validation').text('Validating...');
      TweenMax.to($('.browse-validation'), 0.3, {ease: Power4.easeInOut, height: 'auto', opacity: 1});
      setTimeout(function() {
        if($('#gform_submit_button_14:visible').length == 0) {
            $('.browse-validation').text('Incorrect Password');
        } else {
            $('.browse-validation').text('Success! Click continue to Browse SWAG!');
            Cookies.set('swagpass', 'shown', { expires: 30 });
            TweenMax.to(jQuery('#gform_14 .gform_footer'), 0.3, {ease: Power4.easeInOut, height: 'auto', opacity: 1, padding: '10px 15px'});
        }
      }, 1000);
  });

  var swagpass = Cookies.get('swagpass');
  // SHOW PASSWORD POPUP IF NO COOKIE SET FROM PREVIOUS SUBMISSION
  if(swagpass == undefined) {
      jQuery('.browse-swag').magnificPopup({
          delegate: 'a',
          type:'inline',
          midClick: true
      });
      
      // Handle .browse-swag when it IS the anchor itself ONLY in agency-hero section
      jQuery('.agency-hero a.browse-swag').magnificPopup({
          type:'inline',
          midClick: true
      });
      
      jQuery('.browse-swag').click(function() {
          var showroom = jQuery(this).find('a').attr('data-showroom');
          if(showroom) {
              jQuery('#generated-swag-link').attr("href",showroom);
          }
      });
      if(jQuery('#browse-swag-popup').length) {
          window.addEventListener('message', function(event) {            
            if(event.data.type === 'hsFormCallback' && event.data.eventName === 'onFormSubmit' && event.data.id == '07b6e6c3-913c-4f46-868d-0a3cf02e0910') {
                var swag_url = $("#generated-swag-link").attr('href');
                var swag_url_alt = $("#generated-swag-link-alt").attr('href');
                Cookies.set('swagpass', 'shown', { expires: 365 });
                if(swag_url_alt) {
                    var delay = 500;
                    setTimeout( function() { 
                        window.open(swag_url_alt, '_blank');
                    }, delay );
                }
                if(swag_url) {
                    var delay = 1000;
                    setTimeout( function() { 
                        window.location = swag_url;
                    }, delay );
                }
            }
         });
      }
  } else { 
      // REDIRECT DIRECTLY TO SWAG SHOPS IF COOKIE SET
      jQuery('.browse-swag').click(function(e) {
          var showroom = jQuery(this).find('a').attr('data-showroom');
          if(showroom) {
              window.open(showroom, '_blank');
          } else {
              e.preventDefault();
              window.open('https://shop.soboconcepts.com/', '_blank');
          }
      });
  }

  // OPEN BROWSE SWAG POPUP IF HASH VALUE matches
  if (location.hash === "#browse-swag") {
    $.magnificPopup.open({
      items: {
        src: '#browse-swag-popup' 
      },
      type: 'inline'
    });
  }
  // OPEN GET STARTED POPUP IF HASH VALUE matches
  if (location.hash === "#getstarted") {
    $.magnificPopup.open({
      items: {
        src: '#get-started-popup' 
      },
      type: 'inline'
    });
  }
});